<template>
  <div class="zaymtorus">
    <checker-offers-block :offers="checkerDisplayOffers" />
    <template v-if="isSwiperEnabled">
      <div class="showcase-wrapper">
        <div class="swiper-pagination" ref="pagination"></div>
        <div class="swiper-text__label">Листайте влево</div>
        <div class="swiper showcase-swiper" ref="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
              <div class="card">
                <div class="card-rating">
                  <span class="card-rating__star">★</span>
                  <span class="card-rating__value">{{ offer.rating }}</span>
                </div>

                <div class="card-top">
                  <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
                </div>

                <div class="card-info">
                  <div class="card-info__row">
                    <div class="card-info__img">
                      <img src="/img/sumzaymelo.svg" alt="">
                    </div>
                    <span class="card-info__label">Сумма</span>
                    <span class="card-info__value">до {{ numberFormat(offer.amount) }} ₽</span>
                  </div>
                  <div class="card-info__row">
                    <div class="card-info__img">
                      <img src="/img/periodzaymelo.svg" alt="">
                    </div>
                    <span class="card-info__label">Срок</span>
                    <span class="card-info__value">до {{ offer.period }} дней</span>
                  </div>
                  <div class="card-info__row">
                    <div class="card-info__img">
                      <img src="/img/percentzaymelo.svg" alt="">
                    </div>
                    <span class="card-info__label">Ставка</span>
                    <span class="card-info__value">от 0%</span>
                  </div>
                </div>

                <div class="card-btn" @click="openLinks(offer)">
                  <button type="button">Отправить заявку</button>
                </div>
              </div>
            </div>
          </div>

          <button class="showcase-nav prev" ref="prevBtn" :class="{ hidden: !hasMovedFromFirst }">‹</button>
          <button class="showcase-nav next" ref="nextBtn">›</button>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="showcase-wrapper showcase-wrapper--no-swiper">
        <div class="card" v-for="offer in showcaseOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
          <div class="card-rating">
            <span class="card-rating__star">★</span>
            <span class="card-rating__value">{{ offer.rating }}</span>
          </div>

          <div class="card-top">
            <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
          </div>

          <div class="card-info">
            <div class="card-info__row">
              <div class="card-info__img">
                <img src="/img/sumzaymelo.svg" alt="">
              </div>
              <span class="card-info__label">Сумма</span>
              <span class="card-info__value">до {{ numberFormat(offer.amount) }} ₽</span>
            </div>
            <div class="card-info__row">
              <div class="card-info__img">
                <img src="/img/periodzaymelo.svg" alt="">
              </div>
              <span class="card-info__label">Срок</span>
              <span class="card-info__value">до {{ offer.period }} дней</span>
            </div>
            <div class="card-info__row">
              <div class="card-info__img">
                <img src="/img/percentzaymelo.svg" alt="">
              </div>
              <span class="card-info__label">Ставка</span>
              <span v-if="offer.without_percent" class="card-info__value">от 0%</span>
              <span v-if="!offer.without_percent" class="card-info__value">от 0.1%</span>
              
            </div>
          </div>

          <div class="card-btn" @click="openLinks(offer)">
            <button type="button">Отправить заявку</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import * as Data from "../assets/js/data_params.js";
import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
import CheckerOffersBlock from "./CheckerOffersBlock.vue";

export default {
  name: "ShowcaseZaymtorus",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: { CheckerOffersBlock },

  props: {
    offers: Array,
    checkerOffers: Array,
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return this.getCheckerDisplayOffers();
    },

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },
  },

  methods: {

    numberFormat(n) { return Functions.numberFormat(n); },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      offer.links.forEach(l => window.open(l, "_blank"));
    },

  }
};
</script>

<style lang="css">
@import url(../assets/css/zaymtorus.scss);
</style>

<style lang="css">
.swiper-text__label {
  display: none;
}

@media (max-width: 768px) {
  .swiper-text__label {
    display: block;
    font-weight: 400;
    font-size: 16px;
  }

  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

@media (min-width: 768px) {
  .showcase-wrapper > .swiper-pagination,
  .showcase-nav {
    display: none !important;
  }

  .zaymtorus .showcase-swiper .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    justify-content: flex-start;
  }

  .zaymtorus .showcase-swiper .swiper-slide {
    flex: 0 0 300px;
    max-width: 300px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }

  .zaymtorus .showcase-swiper .card {
    width: 100%;
    max-width: 300px;
    box-sizing: border-box;
  }
}

@media (max-width: 767px) {
  .zaymtorus .showcase-wrapper {
    padding: 0 0 20px;
  }

  .zaymtorus .showcase-wrapper--no-swiper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 16px;
    align-items: center;
  }

  .zaymtorus .showcase-wrapper--no-swiper .card {
    max-width: 320px;
    width: 100%;
  }

  .zaymtorus .showcase-wrapper--no-swiper .swiper-text__label,
  .zaymtorus .showcase-wrapper--no-swiper .swiper-pagination,
  .zaymtorus .showcase-wrapper--no-swiper .showcase-nav {
    display: none !important;
  }

  .zaymtorus .showcase-wrapper > .swiper-pagination {
    display: block;
    position: relative;
    max-width: 310px;
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .zaymtorus .showcase-wrapper > .swiper-pagination .swiper-pagination-progressbar-fill {
    background: #0d9488;
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .showcase-swiper {
    overflow: visible;
    position: relative;
  }

  .zaymtorus .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-slide .card {
    max-width: 310px;
    width: 100%;
  }

  .zaymtorus .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #fff;
    background: #0d9488;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .showcase-nav.prev {
    left: 0px;
  }

  .showcase-nav.next {
    right: 0px;
  }
}

@media (max-width: 430px) {
  .zaymtorus .showcase-wrapper--no-swiper {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
  }

  .zaymtorus .showcase-wrapper--no-swiper .card {
    max-width: 320px !important;
    width: 100% !important;
  }
}
</style>
